var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-sample-list',{ref:"loadmore",staticClass:"pt-sample-list__withData",attrs:{"billId":_vm.billId,"selectSample":_vm.selectSample,"allSelected":_vm.allSelected,"data":_vm.data},on:{"load":_vm.load,"getSelected":_vm.getSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }